export default {
	API_ENDPOINT: process.env.REACT_APP_API_HOST,
	WP2_API_HOST: process.env.REACT_APP_WP2_API_HOST,
	AUTHZERO_DEVELOPMENT_USER_ID:
		process.env.REACT_APP_AUTHZERO_DEVELOPMENT_USER_ID,
};
